// src/components/PageTitleManager.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE = 'https://robomind-edu.com';
const PRIVATE_RE = /^\/(admin|teacher|student\/|studentprofile|sales|democlass|feedback|joinfreeclass|login)/i;

const PageTitleManager = ({ 
  title = '', 
  description = '',
  keywords = '',
  ogImage = 'https://robomind-edu.com/images/social-share-image.jpg'
}) => {
  const location = useLocation();
  const baseTitle = 'Coding, AI & Robotics Classes for Kids in Lebanon | RoboMind';

  useEffect(() => {
    // Update page title (short titles show fully in Google: "Pricing Plans | RoboMind Lebanon")
    const fullTitle = title && title !== 'Home' ? `${title} | RoboMind Lebanon` : baseTitle;
    document.title = fullTitle;

    // One official address per page for Google (no www, no ?utm=…)
    const path = location.pathname.replace(/\/+$/, '') || '/';
    updateLink('canonical', `${SITE}${path}`);
    // dashboards and private links: keep them out of Google
    updateMetaTag('robots', PRIVATE_RE.test(path) ? 'noindex, nofollow' : 'index, follow');
    
    // Update meta tags
    updateMetaTag('description', description);
    updateMetaTag('keywords', keywords);
    updateMetaTag('og:title', fullTitle, 'property');
    updateMetaTag('og:description', description, 'property');
    updateMetaTag('og:url', `${SITE}${path}`, 'property');
    updateMetaTag('og:image', ogImage, 'property');
    updateMetaTag('twitter:title', fullTitle);
    updateMetaTag('twitter:description', description);
    updateMetaTag('twitter:image', ogImage);
    
    // Cleanup function (optional)
    return () => {
      document.title = baseTitle;
    };
  }, [title, description, keywords, ogImage, location.pathname]);
  
  const updateMetaTag = (name, content, attribute = 'name') => {
    if (!content) return;
    
    let meta = document.querySelector(`meta[${attribute}="${name}"]`);
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute(attribute, name);
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', content);
  };
  
  const updateLink = (rel, href) => {
    let link = document.querySelector(`link[rel="${rel}"]`);
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', rel);
      document.head.appendChild(link);
    }
    link.setAttribute('href', href);
  };

  return null; // This component doesn't render anything
};

export default PageTitleManager;